
import PropTypes from 'prop-types'
import React from 'react'
import px from 'add-px'
import './Loader.css'

const Loader = ({ isLoading, children, padding }) =>
  !isLoading
    ? <div>{children}</div>
    : (
      <div className='Loader'>
        <div style={{ height: px(padding) }} />
        <div className='LoaderSpinner' />
      </div>
  )

Loader.defaultProps = {
  padding: 0
}

Loader.propTypes = {
  children: PropTypes.oneOfType([ PropTypes.object, PropTypes.array ]),
  isLoading: PropTypes.bool,
  padding: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ]).isRequired
}

Loader.displayName = 'Loader'

export default Loader



// WEBPACK FOOTER //
// ./ui/Loader.js